export default __webpack_public_path__ + "static/media/green-bg.30d3ea89.png";